import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'
import { Author } from '../interfaces'
import { getPostOffset } from '../utils'

/* eslint-disable import/no-internal-modules */
import Content from '@insided/deprecated-preact-components/common/Content'

export interface ReplyInContentProps {
  id: string
  publicReplyId: string
  title: string
  author: Author
  content: string
  repliedAt: string
}

const ReplyInContent = ({ publicReplyId, title, author, content, repliedAt }: ReplyInContentProps) => {
  const formattedRepliedAt = formatDateInLocalTimezone(new Date(repliedAt).getTime() / 1000)

  return (
    <div className='post--answer--container'>
      <strong>{title} by {author.username} - {formattedRepliedAt}</strong>
      <Content content={content} isControl />
      <a
        className='js--perma-link'
        onClick={() => {
          const postOffset = getPostOffset(publicReplyId)
          window.location.hash = `#postid/${publicReplyId}`
          window.scrollTo({ behavior: 'smooth', top: postOffset })
        }}
      >See original</a>
    </div>
  )
}

export default ReplyInContent
